module.exports = __webpack_public_path__ + "static/media/play.d20dbc16.svg";